module.exports = __webpack_public_path__ + "static/media/heart-empty-new.edfae980.svg";